import { render, staticRenderFns } from "./FermatsLastTheoremArticle.vue?vue&type=template&id=a5dd9520&"
import script from "./FermatsLastTheoremArticle.vue?vue&type=script&lang=js&"
export * from "./FermatsLastTheoremArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports